import React from "react";
import {
  StyledEnter,
  Header,
  BoldText,
  SubText,
  Row,
  Bar,
  BoxRow,
  Column,
  IconBox,
  BoldTitle,
  Subtitle,
  Icon,


} from "./styles";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import { EncircledIcon } from "../EncircledIcon/EncircledIcon";
import { Posts } from "../../components/Posts/Posts";
import follow from "../../assets/follow.png";
import share from "../../assets/share.png";
import feels from "../../assets/feels-good.png";
import win from "../../assets/win.png";
import fb from "../../assets/social-icon-facebook.png";
import insta from "../../assets/social-icon-instagram.png";
import linkedin from "../../assets/social-icon-linkedin.png";
import twitter from "../../assets/social-icon-twitter.png";
import youtube from "../../assets/social-icon-youtube.png";
import { StyledButton, TextRule } from "../Button/styles";

export const Enter = ({ circleAnimation }) => (
  <StyledEnter>
    <Header>
      <Container fluid className="mb-4">
        <Row className="justify-content-center w-100">
          <Col xs={12} className="mb-4">
            <Posts />
          </Col>
          <Col md={12} className="text-center">
            <BoldText>How To Enter</BoldText>
            <SubText>Entering is as easy as 1 - 2 - 3 ...and 4</SubText>
          </Col>
        </Row>
      </Container>
    </Header>
    {circleAnimation ? (
      <Row>
        <BoxRow>
          <Column className="encircled">
            <IconBox toggle={circleAnimation}>
              <Icon
                href="https://www.facebook.com/SunWestMortgage/"
                target="_blank"
                top={-3.3}
                icon={fb}
              >
              </Icon>
              <Icon
                href="https://www.instagram.com/sunwestmortgage.inc/"
                target="_blank"
                top={-1.5}
                left={-8}
                icon={insta}
              >
              </Icon>
              <Icon
                href="https://www.youtube.com/user/SunWestMortgageCo"
                target="_blank"
                icon={youtube}
                top={2.25}
                left={-11}
              >
              </Icon>
              <Icon
                href="https://twitter.com/SunWestMortgage"
                target="_blank"
                top={-1.5}
                left={8}
                icon={twitter}
              >
              </Icon>
              <Icon
                href="https://www.linkedin.com/company/sun-west-mortgage-company/"
                target="_blank"
                left={11}
                top={2.25}
                icon={linkedin}
              >
              </Icon>
              <EncircledIcon
              toggle={circleAnimation}
              icon={follow}
              colorOne="#FFFFFF"
              colorTwo="#FFFFFF"
              colorThree="#FFFFFF"
              />
            </IconBox>

            <BoldTitle circleAnimation={circleAnimation}>Follow</BoldTitle>
            <Subtitle>
              Follow Sun West Mortgage on Instagram to be eligible and check out our
              other pages too.
            </Subtitle>
            <StyledButton href=" https://www.swmc.com/mytruehome/contest-rules" target="_blank" className="pt-3">
              <TextRule>Contest Rules</TextRule>
            </StyledButton>
          </Column>
          <Column className="encircled">
            <EncircledIcon
              toggle={circleAnimation}
              icon={share}
              colorOne="#FFFFFF"
              colorTwo="#FFFFFF"
              colorThree="#FFFFFF"
            />
            <BoldTitle circleAnimation={circleAnimation}>Share</BoldTitle>
            <Subtitle>
              Share a photo or video on Instagram using the hashtags <span className="hashTag">#MyTrueHome</span> and
              <span className="hashTag"> #SunWestMortgage</span>, with a description of what makes your home,
              truly yours.
            </Subtitle>
          </Column>
        </BoxRow>
        <BoxRow>
          <Column className="encircled">
            <EncircledIcon
              toggle={circleAnimation}
              icon={feels}
              colorOne="#FFFFFF"
              colorTwo="#FFFFFF"
              colorThree="#FFFFFF"
            />
            <BoldTitle circleAnimation={circleAnimation}>Feel Good</BoldTitle>
            <Subtitle>
              You can feel good knowing you're posting for a good cause. For
              every post, Sun West Mortgage will donate $1 to TACA.
            </Subtitle>
          </Column>
          <Column className="encircled">
            <EncircledIcon
              toggle={circleAnimation}
              icon={win}
              colorOne="#FFFFFF"
              colorTwo="#FFFFFF"
              colorThree="#FFFFFF"
            />

            <BoldTitle circleAnimation={circleAnimation}>Win</BoldTitle>
            <Subtitle>
              Each Wednesday for 11 weeks, Sun West will feature one post and
              award the winner $1,000.
            </Subtitle>
          </Column>
        </BoxRow>
      </Row>
    ) : (
      <Row style={{ opacity: 0 }}>
        <BoxRow>
          <Column className="encircled">
            <IconBox toggle={circleAnimation}>
              <Icon
                href="https://www.facebook.com/SunWestMortgage/"
                target="_blank"
                top={-3.3}
                icon={fb}
              >
              </Icon>
              <Icon
                href="https://www.instagram.com/sunwestmortgage.inc/"
                target="_blank"
                top={-1.5}
                left={-8}
                icon={insta}
              >
              </Icon>
              <Icon
                href="https://www.youtube.com/user/SunWestMortgageCo"
                target="_blank"
                icon={youtube}
                top={2.25}
                left={-11}
              >
              </Icon>
              <Icon
                href="https://twitter.com/SunWestMortgage"
                target="_blank"
                top={-1.5}
                left={8}
                icon={twitter}
              >
              </Icon>
              <Icon
                href="https://www.linkedin.com/company/sun-west-mortgage-company/"
                target="_blank"
                left={11}
                top={2.25}
                icon={linkedin}
              >
              </Icon>
              <Icon
                icon={follow}
              />
            </IconBox>

            <BoldTitle circleAnimation={circleAnimation}>Follow</BoldTitle>
            <Subtitle>
              Follow Sun West Mortgage on Instagram to be eligible and check out
              our other pages too.
            </Subtitle>
          </Column>

          <Column className="encircled">
            <EncircledIcon
              toggle={circleAnimation}
              icon={share}
              colorOne="#083f88"
              colorTwo="#FFFFFF"
              colorThree="#E1ECFA"
            />
            <BoldTitle circleAnimation={circleAnimation}>Share</BoldTitle>
            <Subtitle>
              Share a photo or video on Instagram using the hashtags #mytruehome and
              #sunwestmortgage, with a description of what makes your home, truly
              yours.
            </Subtitle>
          </Column>
        </BoxRow>
        <BoxRow>
          <Column className="encircled">
            <EncircledIcon
              toggle={circleAnimation}
              icon={feels}
              colorOne="#00aae4"
              colorTwo="#FFFFFF"
              colorThree="#E5F9FF"
            />
            <BoldTitle circleAnimation={circleAnimation}>Feel Good</BoldTitle>
            <Subtitle>
              You can feel good knowing you're posting for a good cause. For
              every post, Sun West Mortgage will donate $1 to TACA.
            </Subtitle>
          </Column>
          <Column className="encircled">
            <EncircledIcon
              toggle={circleAnimation}
              icon={win}
              colorOne="#083f88"
              colorTwo="#FFFFFF"
              colorThree="#E1ECFA"
            />

            <BoldTitle circleAnimation={circleAnimation}>Win</BoldTitle>
            <Subtitle>
              Each Wednesday for 8 weeks, Sun West will feature one story and
              award the winner $1,000.
            </Subtitle>
          </Column>
        </BoxRow>
      </Row>
    )}
  </StyledEnter>
);
